import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AiReportAvailabilityProvider } from "./context/AiReportAvailabilityContext";
import IndexPage from "./pages/IndexPage";
import LoginPage from "./pages/LoginPage";
import RegisterClientPage from "./pages/RegisterClientPage";
import ConfirmAccountPage from "./pages/ConfirmAccountPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import CompanyHotelsPage from "./pages/CompanyHotelsPage";
import CompanyHotelDetailsPage from "./pages/CompanyHotelDetailsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import CompaniesPage from "./pages/CompaniesPage";
import CompetitorsPage from "./pages/CompetitorsPage";
import AdminHotelsPage from "./pages/AdminHotelsPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import UserProfilePage from "./pages/UserProfilePage";
import AnalyticsPlatformsPage from "./pages/AnalyticsPlatformsPage";
import AnalyticsCategoriesPage from "./pages/AnalyticsCategoriesPage";
import AnalyticsTrendsCategoriesPage from "./pages/AnalyticsTrendsCategoriesPage";
import AnalyticsDashboardPage from "./pages/AnalyticsDashboardPage";
import AnalyticsCompetitorTrendsPage from "./pages/AnalyticsCompetitorTrendsPage";
import AiAssistantPage from "./pages/AiAssistantPage";
import AnalyticsDashboardTestPage from "./pages/AnalyticsDashboardTestPage";
import AnalyticsDashboardV1TestPage from "./pages/AnalyticsDashboardV1TestPage";
import AnalyticsDashboardDiffTestPage from "./pages/AnalyticsDashboardDiffTestPage";
import AnalyticsDeltaByDatePage from "./pages/AnalyticsDeltaByDatePage";
import MappingPage from "./pages/MappingPage";
import ForbiddenPage from "./pages/ForbiddenPage";

function Stub({ title }: { title: string }) {
  return <div className="p-8">{title}</div>;
}

export default function App() {
  return (
    <AuthProvider>
      <AiReportAvailabilityProvider>
      <Router>
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/auth/login" element={<LoginPage />} />
          <Route path="/auth/register" element={<RegisterClientPage />} />
          <Route path="/register" element={<RegisterClientPage />} />
          <Route path="/confirm-account" element={<ConfirmAccountPage />} />
          <Route path="/auth/confirm-account" element={<ConfirmAccountPage />} />
          <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/auth/reset-password" element={<ResetPasswordPage />} />

          {/* Пример защищённой зоны */}
          <Route element={<ProtectedRoute />}>
            <Route path="/my/objects" element={<CompanyHotelsPage />} />
            <Route path="/my/objects/:id" element={<CompanyHotelDetailsPage />} />
            <Route path="/account" element={<UserProfilePage />} />
            <Route path="/ai-assistant" element={<AiAssistantPage />} />
            <Route path="/ai-report" element={<AiAssistantPage />} />
            <Route path="/analytics/dashboard" element={<AnalyticsDashboardPage />} />
            <Route path="/analytics/trends/competitors" element={<AnalyticsCompetitorTrendsPage />} />
            <Route path="/analytics/competitor-trends" element={<AnalyticsCompetitorTrendsPage />} />
            <Route path="/analytics/date-delta" element={<AnalyticsDeltaByDatePage />} />
            <Route path="/dashtest" element={<AnalyticsDashboardTestPage />} />
            <Route path="/dashtestv1" element={<AnalyticsDashboardV1TestPage />} />
            <Route path="/dashtestdiff" element={<AnalyticsDashboardDiffTestPage />} />
            <Route path="/analytics/platforms" element={<AnalyticsPlatformsPage />} />
            <Route path="/analytics/categories" element={<AnalyticsCategoriesPage />} />
            <Route path="/analytics/trends/categories" element={<AnalyticsTrendsCategoriesPage />} />
          </Route>

          <Route element={<ProtectedRoute allowRoles={["admin"]} />}>
            <Route path="/admin" element={<Stub title="Admin area" />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/users" element={<AdminUsersPage />} />
          <Route path="/objects" element={<AdminHotelsPage />} />
          <Route path="/competitors" element={<CompetitorsPage />} />
          <Route path="/mapping" element={<MappingPage />} />
        </Route>

          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
      </AiReportAvailabilityProvider>
    </AuthProvider>
  );
}
